import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { Clase } from 'src/app/Models/clase/clase';
import { DataService } from 'src/app/Service/data.service';
import { SubClase } from 'src/app/Models/subclase/sub-clase';
import { ClaseComponent } from '../../clase/clase/clase.component';
import { Usuario } from 'src/app/Models/usuario/usuario';

@Component({
    selector: 'app-sub-clase',
    templateUrl: './sub-clase.component.html'
})
export class SubClaseComponent implements OnInit {
    @ViewChild('btnshow', null) btnshow: ElementRef;
    @ViewChild('btnclose', null) btnclose: ElementRef;
    @ViewChild('txtfirt', null) txtfirt: ElementRef;
    
    @ViewChild(AlertComponent, null) alert: AlertComponent;
    @ViewChild(LoadingComponent, null) loading: LoadingComponent;
    @ViewChild(InfoComponent, null) info: InfoComponent;
    @ViewChild('mdclase', null) fmclase: ClaseComponent;
    public isShow: boolean = false;
    public pagina: number = 0;
    public clases: Clase[] = [];
    public subclases: SubClase[] = [];
    public subclase: SubClase = new SubClase();
    public subclaseres:SubClase = new SubClase();
    public isEdit: boolean = false;
    public funcion: Function = null;
    public pagsubclase: any;
    public total:number=0;
    public adddescripcion: boolean = false;
    public search = '';
    public modal="";
    public showdelete:boolean = false;
    public usuario:Usuario= new Usuario();
    public waitclase:boolean = false;
    public zindex:number = 10000;
    constructor(private data: DataService) { }

    ngOnInit() {
    }

    public show(affterfunction: Function = null) {
        this.funcion = affterfunction;
        this.isShow = true;
        this.showTab(1);
        this.showdelete=false;
        setTimeout(() => {
            this.btnshow.nativeElement.click();
            this.info.hide();
            this.usuario = this.data.getCurrentUser();
            this.GetClase();
            this.GetData();
        }, 10);
    }

    GetData() {
        this.loading.show("cargando..");
        this.subclases=[];
        let send;

        this.data.Exists(this.search)?
        send = this.data.GetFromValue(this.data.api.subclase, 'like', this.search):
        send = this.data.GetSimple(this.data.api.subclase)

        send.subscribe(r => {
            this.loading.hide();
            if (r.length>0) { this.subclases = r; this.total = this.subclases.length;}
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }
    ShowInfoItem(i){
        this.subclase = i as SubClase;
        this.showTab(3);
    }
    ShowNewItem() {
        this.isEdit = false;
        this.showTab(2);
        this.subclase = new SubClase();
        this.adddescripcion = false;
        setTimeout(() => { this.txtfirt.nativeElement.focus(); }, 10);
    }
    ShowEditItem(i) {
        this.isEdit = true;
        this.showTab(2);
        this.subclase = i as SubClase;
        // if(this.nacionalidad.descripcion != ""){this.adddescripcion = true;}else{this.adddescripcion = false;}
        setTimeout(() => { this.txtfirt.nativeElement.focus();  }, 10);
    }
    ShowDeleteItem(i){
        this.subclase = i as SubClase;
        this.modal='';
        this.showdelete= true;
        this.info.show("¿Estimado usuario(a) deseas Quitar/Eliminar el elemento [nombre:\""+this.subclase.nombre+"\"] del sistema? ",1,null,{ cancelText: 'No, Cancelar', successText: 'Si, Continuar', isCancel: true },()=>{this.Delete();},()=>{this.showTab(1); this.modal='modal-lg'; this.showdelete=false; this.info.hide();},20);
    }
    ValidateControl():boolean{
        return (this.subclase.nombre != '' && this.subclase.nombre != undefined ) && (this.subclase.idclase.idclase != '' && this.subclase.idclase.idclase != undefined ) ? true : false;
    }
    Delete(){
        this.loading.show('eliminando elemento');
        this.data.Delete(this.data.api.subclase,this.subclase.idsubcla).subscribe(r=>{
            this.loading.hide();
            this.info.show(r.message,2,null,null,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});
            if(r.status == 'success') { this.GetData();}
        },e=>{this.info.error(e.error.text,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});})
    }

    showTab(i) {

        this.pagina = i;
        if(this.pagina == 1){this.modal ='modal-lg';}
        else{this.modal='';}
    }

    close() {
        this.btnclose.nativeElement.click();
        setTimeout(() => { this.isShow=false; }, 1000);
        setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
    }

    GetClase(){
        this.waitclase=true;
        this.data.GetSimple(this.data.api.clase).subscribe(r=>{
            this.clases = r;
            this.waitclase=false;
        },e=>{console.log(e.error.text);});
    }

    ShowClase(){
        this.fmclase.show(()=>{this.GetClase(); this.funcion();});
    }
    Save() {
        if (this.isEdit) {
            this.loading.show("Actualizando..");
            this.subclase.usuario_id = this.data.getCurrentUser().id;
            this.data.Put(this.data.api.subclase, this.subclase.idsubcla, this.subclase).subscribe(r => {
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        else {
            this.loading.show("Registrando..");
            this.subclase.usuario_id = this.data.getCurrentUser().id;
            this.data.Post(this.data.api.subclase, this.subclase.getData()).subscribe(r => {
                this.subclaseres=r.data;
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        if (this.funcion != null) {
            this.funcion();
        }
    }

}
